module.exports = __webpack_public_path__ + "static/img/GalaxyTabS3.872ecd34.png";